import styled from "@emotion/styled/macro";

export const LinkedItemModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
    border-radius: 0px 0px 12px 12px;
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 24px 12px;
    border-bottom: 1px solid #DDE3EB;
    position: relative;
`;



export const ModalTitle = styled.h2`
    font-family: Circular;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.375em;
    color: #1A1B1D;
    margin: 0;
`;

export const ItemCount = styled.div`
    background: #1A1B1D;
    color: #F7F8F9;
    border-radius: 21px;
    padding: 1px 5px;
    font-family: Circular;
    font-weight: 450;
    font-size: 12px;
    line-height: 1.265em;
    text-align: center;
    min-width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FileIcon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
        width: 20px;
        height: 20px;
    }
`;

export const FileName = styled.span`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265em;
    color: #1A1B1D;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 250px;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #9097A3;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    
    &:hover {
        color: #1A1B1D;
    }
`;

export const ModalBody = styled.div`
    flex: 1;
    padding: 24px 32px 0px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
`;

export const SearchSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    p {
        font-family: Circular;
        font-weight: 450;
        font-size: 12px;
        line-height: 1.265em;
        color: #585D66;
        margin: 0;
    }
`;

export const SearchInputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const SearchInput = styled.input`
    border: 1px solid #585D66;
    border-radius: 40px;
    padding: 12px 16px 12px 40px;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265em;
    color: #1A1B1D;
    width: 100%;
    box-sizing: border-box;
    
    &::placeholder {
        color: #9097A3;
    }
    
    &:focus {
        outline: none;
        border-color: #1A1B1D;
    }
`;

export const SearchIcon = styled.div`
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    
    svg {
        width: 16px;
        height: 16px;
        
        circle, line {
            stroke: #9097A3;
        }
    }
`;

export const ItemsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px 0px 96px 0px;
`;

export const SectionTitle = styled.h3`
    font-family: Circular;
    font-weight: 450;
    font-size: 12px;
    line-height: 1.265em;
    color: #9097A3;
    margin: 0;
    padding: 8px 0px;
`;

export const ItemsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ItemRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 8px 8px 16px;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
        background: #F1F3F5;
    }
`;

export const ItemContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
`;

export const ItemDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
`;

export const ItemName = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265em;
    color: #1A1B1D;
    display: flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
`;

export const ItemNameText = styled.span`
    :hover{
        text-decoration: underline;
    }
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    .ant-checkbox-input, .ant-checkbox-inner {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        :focus{
            border-color: #1A1B1D;
        }
    }
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: #1A1B1D;
    }
    .ant-checkbox-checked{
        .ant-checkbox-inner {
            background-color: #1A1B1D;
            border-color: #1A1B1D;
            ::after{
                transform: rotate(45deg) scale(1) translate(-56%, -58%);
            }
        }
        ::after {
            border-color: #1A1B1D;
        }
    }
    :hover{
        .ant-checkbox-inner {
            border-color: #1A1B1D;
        }
    }
    &.ant-checkbox-wrapper-checked:hover{
        .ant-checkbox-inner {
            border-color: #1A1B1D;
        }
    }
`;

export const SaveButtonContainer = styled.div`
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    padding: 16px 0px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
`;

export const SaveButton = styled.button`
    background: #1A1B1D;
    color: #FFFFFF;
    border: none;
    border-radius: 40px;
    padding: 0 32px;
    height: 48px;
    font-family: Circular;
    font-weight: 450;
    font-size: 16px;
    line-height: 1.265;
    cursor: pointer;
    width: 444px;
    box-shadow: 0px 0.5px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
    pointer-events: auto;
    
    &:hover {
        background: #2A2B2D;
    }
    
    &:disabled {
        background: #9097A3;
        cursor: not-allowed;
    }
`;

export const EmptyState = styled.div`
    padding: 32px 16px;
    text-align: center;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265em;
    color: #9097A3;
`;



export const SectionSeparator = styled.div`
    width: 100%;
    height: 1px;
    background: #DDE3EB;
    margin: 8px 0;
`; 